import styled from 'styled-components/macro';
import { FlexJustifyBetween } from '../../../../../shared-styles/flex';

export const InfoSectionContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.numCols}, 1fr);
  column-gap: ${(props) => props.theme.spacing(20)};
  padding: ${(props) => (!props.removePadding ? props.theme.spacing(20) : 0)};
  border-bottom: ${(props) => (props.outlineBottom ? `2px dashed ${props.theme.palette.lightGray[100]}` : null)};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'transparent')};
  row-gap: ${(props) => props.rowGap}px;
`;

export const InfoSectionHeader = styled.h3`
  font-weight: ${(props) => props.theme.typography.weight.bold};
`;

export const InfoSectionHeaderContainer = styled.div`
  ${FlexJustifyBetween}
  background-color: ${(props) => props.theme.palette.custom.headerLightBlue};
  border-bottom: 1px solid ${(props) => props.theme.palette.lightBlue[75]};
  border-top: 1px solid ${(props) => props.theme.palette.lightBlue[75]};
  padding: ${(props) => props.theme.spacing(5)} ${(props) => props.theme.spacing(20)};
`;
